import logo from "@/assets/galahadji-logo.png";

export function printFilledForm(title, bodyHtml, logoUrl) {
  const w = window.open("", "_blank", "width=900,height=1100");
  if (!w) return;
  w.document.write(`<!doctype html><html><head><title>${title}</title><style>
    body{font-family:Georgia,'Times New Roman',serif;color:#111;margin:48px auto;max-width:760px;padding:0 24px;line-height:1.55}
    h1,h2,h3{font-family:Arial,Helvetica,sans-serif}
    table{border-collapse:collapse;width:100%}
    .doc-head{display:flex;align-items:center;gap:16px;border-bottom:3px solid #d4a017;padding-bottom:14px;margin-bottom:26px}
    .doc-head img{height:72px;width:auto;object-fit:contain}
    @media print{.no-print{display:none}}
  </style></head><body>
  <div class="doc-head"><img src="${logoUrl || logo}" alt="logo"/><div>
    <div style="font-family:Arial;font-weight:bold;font-size:18px">Galahadji Acquisitions Inc</div>
    <div style="color:#777;font-size:12px">Las Vegas, NV · Acquire · Transform · Build Wealth</div></div></div>
  ${bodyHtml}
  <script>window.onload=function(){setTimeout(function(){window.print()},400)}</script>
  </body></html>`);
  w.document.close();
}
